<template>
    <label :for="id">{{ label }}</label>
    <input type="text"
           :name="name"
           class="form-control"
           :id="id"
           v-model="city"
           ref="cityInput"
    />
</template>

<script>
import { reactive, toRefs, onMounted } from 'vue'

import emitter from '../../utils/emitter'

export default {

    props: [
        'label',
        'id',
        'name',
        'value',
        'type'
    ],

    setup(props) {

        const state = reactive({
            city: '',
            cityInput: null
        })

        onMounted( () => {

            state.city = props.value

            emitter.on('onZipSelected', data => {
                if ( data.type === props.type ) {
                    state.city = data.city

                    // V zavislosti od frontendu
                    // state.cityInput.classList.add('filled')
                    // state.cityInput.parentElement.classList.add('focused')
                }
            })
        })

        return {
            ...toRefs(state)
        }
    }
}
</script>
